module.exports = __webpack_public_path__ + "static/media/discoverability_black.83f913f2.svg";